import { graphql } from "gatsby";
import React from "react";
import { getImagePath } from "../../../utils/images";
import * as styles from "./ParagraphImageOrText.module.scss";

export interface ParagraphImageOrTextProps {
	data: Queries.ParagraphImageOrTextDataFragment;
}
export const ParagraphImageOrText: React.FC<ParagraphImageOrTextProps> = ({
	data,
}) => {
	if (data.__typename === "paragraph__step_image") {
		if (!data.relationships.field_featured_image.field_media_image) {
			return null;
		}
		return (
			<div className={styles.imagecontainer}>
				<img
					src={getImagePath(
						"400x300",
						data.relationships.field_featured_image.field_media_image?.uri,
					)}
					alt={data.relationships.field_featured_image.field_media_image?.alt}
				/>
			</div>
		);
	}
	if (!data.field_text.value?.length) {
		return null;
	}
	return (
		<div
			// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
			dangerouslySetInnerHTML={{ __html: data.field_text.value }}
		/>
	);
};

export const fragment = graphql`
    fragment ParagraphImageOrTextData on ParagraphImageOrText {
        __typename
        ...ParagraphStepTextData
        ...ParagraphStepImageData
    }

    fragment ParagraphStepTextData on paragraph__step_text {
        __typename
        id
        field_text {
            value
        }
    }
    fragment ParagraphStepImageData on paragraph__step_image {
        __typename
        id
        relationships {
            field_featured_image {
                ...MediaImageData
            }
        }
    }
`;
